module.exports = __webpack_public_path__ + "static/media/header.276eb6f0.png";